import { ThemeProvider as FenrirThemeProvider } from '@rtkwlf/fenrir-react';

import {
  FenrirProvider as FenrirV2Provider,
  useThemeMode as useFenrirV2Theme,
} from '@packages/fenrir/fenrir-provider';
import { type Timezone } from '@packages/fenrir/fenrir-provider/timezone';

import { GlobalStyles } from './global-styles';

import '@rtkwlf/fenrir-react/style.css';

const FenrirV1Provider = ({ children }: React.PropsWithChildren) => {
  const { mode } = useFenrirV2Theme();

  return <FenrirThemeProvider themeMode={mode}>{children}</FenrirThemeProvider>;
};

type ThemeProviderProps = React.PropsWithChildren<{
  initialMode?: React.ComponentProps<typeof FenrirV2Provider>['initialMode'];
  defaultTimezone?: Timezone;
}>;

export const ThemeProvider = ({
  children,
  initialMode,
  defaultTimezone,
}: ThemeProviderProps) => {
  return (
    <FenrirV2Provider
      initialMode={initialMode}
      defaultTimezone={defaultTimezone}
    >
      <FenrirV1Provider>
        <GlobalStyles />
        {children}
      </FenrirV1Provider>
    </FenrirV2Provider>
  );
};
